import React, { useState } from "react";
import Map from "../../components/Map/Map";
import "./ContactPage.scss";
import Contact from "../../components/Contact/Contact";
export default function ContactPage() {
  const [currentLocation, setLocation] = useState({
    lat: 49.2786062,
    lng: -123.0999113,
  });

  return (
    <div className="contact">
      <div className="contact__wrap">
        <Map currentLocation={currentLocation} setLocation={setLocation} />{" "}
        <div className="contact__body">
          <Contact />
        </div>
      </div>
    </div>
  );
}
